/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientOrganismAntibioticSusceptibility from './patient-organism-antibiotic-susceptibility';
import PatientOrganismAntibioticSusceptibilityDetail from './patient-organism-antibiotic-susceptibility-detail';
import PatientOrganismAntibioticSusceptibilityUpdate from './patient-organism-antibiotic-susceptibility-update';
import PatientOrganismAntibioticSusceptibilityDeleteDialog from './patient-organism-antibiotic-susceptibility-delete-dialog';

const PatientOrganismAntibioticSusceptibilityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientOrganismAntibioticSusceptibility />} />
    <Route path="new" element={<PatientOrganismAntibioticSusceptibilityUpdate />} />
    <Route path=":id">
      <Route index element={<PatientOrganismAntibioticSusceptibilityDetail />} />
      <Route path="edit" element={<PatientOrganismAntibioticSusceptibilityUpdate />} />
      <Route path="delete" element={<PatientOrganismAntibioticSusceptibilityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientOrganismAntibioticSusceptibilityRoutes;
